/* eslint-disable camelcase */
import { Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { StudentSearchService } from './student-search.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { YearService } from '../year/year.service';
import { School } from '../year/school.model';
import { StudentSearchModel } from './student-search-model';
import { StudentService } from '../student/student.service';
import { Student } from '../student/student.model';
import { Router } from '@angular/router';
import { UserPreferencesService } from '../user-preferences/user-preferences.service';
import { LoginService } from '../../shared-modules/login/login.service';
import * as moment from 'moment';
import { RegexDirective } from '../directives/regex.directive';
import { StudentSearchPreferences } from './student-search-preferences';
import { AdvancedStudentSearchComponent } from './advanced-student-search/advanced-student-search.component';
import { DataQueryService } from '../../classroom360/data-query/data-query.service';
import { Subscription } from 'rxjs';
import { DataQueryResult } from '../../classroom360/data-query/data-query-result.model';
import { DataQueryInformation } from '../../classroom360/data-query/data-query-information';
import { DataQuery } from '../../classroom360/data-query/data-query.model';
import { System } from '../System';
import { SharedService } from '../shared.service';
import { StudentList } from '../../classroom360/student-lists/student-list.model';
import { StudentListsService } from '../../classroom360/student-lists/student-lists.service';
import { UserPermission } from '../user/user-permission.model';
import { UserService } from '../user/user.service';
import { AddEditStudentListDialogComponent } from '../../classroom360/student-lists/add-edit-student-list-dialog/add-edit-student-list-dialog.component';
import { EnterCsvDialogComponent } from '../enter-csv-dialog/enter-csv-dialog.component';
import { ErrorList } from '../controls/error-prompt/error-list.model';
import { StudentSearchWarningComponent } from './student-search-warning/student-search-warning.component';
import { Classroom360Service } from '../../classroom360/classroom360.service';
import { StudentListModalComponent } from './student-list-modal/student-list-modal.component';
import { SecurityService } from '../security/security.service';
import { take } from 'rxjs/operators';
import * as _ from 'lodash';
import { TylerMatTableDataSource } from '../angular-material/extended.class';
import { StudentSearchCriteria } from './student-search-criteria.model';
import { MassEmailViewComponent } from '../../shared-components/mass-email-view/mass-email-view.component';
import { MassEmail } from '../../shared-components/mass-email-view/mass-email.model';
@Component({
    selector: 'student-search',
    templateUrl: 'student-search.component.html',
    styleUrls: ['./student-search.component.css'],
    encapsulation: ViewEncapsulation.None
})

export class StudentSearchComponent implements OnInit, OnDestroy {
    // Properties
    // @ViewChild(DatatableComponent) dataTableAPI: DatatableComponent;
    @ViewChild(MatMenuTrigger, { static: true }) trigger: MatMenuTrigger;
    subscriptions: Subscription[] = [];
    studentSearchData: Student[] = [];
    studentGridData: Student[] = [];
    selectedStudents: Student[] = [];
    // ----- MAt Table properties ONE-6748-------
    dataSource: TylerMatTableDataSource = new TylerMatTableDataSource(this.studentGridData);
    columnsToDisplay = ['SelectAll', 'Student #', 'First Name', 'Last Name', 'Alerts', 'Grade', 'Enrollment', 'Enroll Date', 'DOB', 'School', 'Status', 'Homeroom Teacher', 'State ID', 'Menue'];
    private _paginator: MatPaginator;
    @ViewChild(MatPaginator, { static: true }) set paginator(value: MatPaginator) {
        this._paginator = value;
        this.dataSource.paginator = value;
    }
    _sort: MatSort;
    @ViewChild(MatSort, { static: true }) set sort(value: MatSort) {
        this._sort = value;
        this.dataSource.sort = value;
    }

    get sort(): MatSort {
        return this._sort;
    }
    // -------------------
    originalStudentSearchData: StudentSearchModel[] = [];
    searchCriteria: StudentSearchCriteria;
    sortOrder: any[];
    searchCriteriaLoaded = false;
    studentIds = [];
    regularExpressions = [{ name: 'Starts With', value: 'startsWith' }, { name: 'Ends With', value: 'endsWith' }, {
        name: 'Contains',
        value: 'contains'
    }];
    currentYear;
    showAlert = true;
    isV10: Boolean;
    showStudentAlerts: boolean;
    prepopulateStudentSearch: boolean;
    defaultCursorPosition: number;
    selectedStudentHistory: Student[];
    schools: School[];
    allStudentsSelected = false;
    gridHeight;
    closeClicked = false;
    activeFilters = [];
    referral = false;
    defaultColumns = [ // changing this requires a change to the restoreDefaultsClick function
        { name: 'Student #', active: true, regEx: 'startsWith' },
        { name: 'First Name', active: true, regEx: 'startsWith' },
        { name: 'Last Name', active: true, regEx: 'startsWith' },
        { name: 'Alerts', active: true, regEx: 'startsWith' },
        { name: 'Grade', active: true, regEx: 'startsWith' },
        { name: 'Enrollment', active: true, regEx: 'startsWith' },
        { name: 'Enroll Date', active: true, regEx: 'startsWith' },
        { name: 'DOB', active: true, regEx: 'startsWith' },
        { name: 'School', active: true, regEx: 'startsWith' },
        { name: 'Status', active: true, regEx: 'startsWith' },
        { name: 'Homeroom Teacher', active: false, regEx: 'startsWith' },
        { name: 'State ID', active: false, regEx: 'startsWith' }
    ];
    // defaultMatTableColumns is depends on defaultColumns // ONE-6748
    // if make any changes in defaultColumns object then changes should require in defaultMatTableColumns object
    defaultMatTableColumns = [
        { name: 'Student #', active: true, MatTableColumn: 'StudentNumber' },
        { name: 'First Name', active: true, MatTableColumn: 'FirstName' },
        { name: 'Last Name', active: true, MatTableColumn: 'LastName' },
        { name: 'Alerts', active: true, MatTableColumn: 'StudentAlerts' },
        { name: 'Grade', active: true, MatTableColumn: 'Grade' },
        { name: 'Enrollment', active: true, MatTableColumn: 'Enrollment' },
        { name: 'Enroll Date', active: true, MatTableColumn: 'EnrollmentDateAsDate' },
        { name: 'DOB', active: true, MatTableColumn: 'DateOfBirthAsDate' },
        // { name: 'Enroll Date', active: true, MatTableColumn: 'EnrollmentDate' },
        // { name: 'DOB', active: true, MatTableColumn: 'DateOfBirth' },
        { name: 'School', active: true, MatTableColumn: 'EnrollmentSchool' },
        { name: 'Status', active: true, MatTableColumn: 'EnrollmentStatus' },
        { name: 'Homeroom Teacher', active: false, MatTableColumn: 'Homeroom_Teacher' },
        { name: 'State ID', active: false, MatTableColumn: 'StudentDOENumber' }
    ];
    redirectUrl = '';
    allSchoolsValue: string;
    inputBuffer: boolean;
    studentSearchCalled = false;

    hideSaveButton = false;
    hidNextButton = false;
    showLargeHeaderMessage = false;

    // filters
    studentNumberFilter: string;
    firstNameFilter: string;
    lastNameFilter: string;
    gradeFilter: string;
    enrollmentFilter: string;
    enrollDateFilter: string;
    dateOfBirthFilter: string;
    schoolFilter: string;
    statusFilter: string;
    studentDOENumberFilter: string;
    homeroomTeacherFilter: string;

    headerMessage: string;
    acceptLabel = 'Select';
    studentNumberRegExp = /^[^\s,]+(,[^\s,]+)*$/;
    studentNumberKeyRestriction = /[^\s,]|,/;
    toggleSelectedStudents = false;

    // Permissions
    permissions: UserPermission[] = [];
    addStudentListPrivilegeId = 2206;
    addStudentList = false;

    // Data Query Properties
    information = new DataQueryInformation();
    private _currentQuery = new DataQuery();

    // Student List Properties
    private _studentList: StudentList = null;
    studentLists: StudentList[] = [];

    // Injected Properties
    returnSelectedStudents = true;
    performRoute = false;
    searchAndSelect = false;
    returnSingle = false;
    returnAll = false;
    currentSchool: boolean;
    schoolId: number;
    creatingStudentList = false;
    useLastSelectedSchool = true;
    disableSchoolDropdown = false;
    shortingBy = '';
    clickHandler = (event: any) => { };

    // Class Functions
    constructor(
        private studentSearchService: StudentSearchService,
        private yearService: YearService,
        private userPreferencesService: UserPreferencesService,
        private studentService: StudentService,
        private router: Router,
        private loginService: LoginService,
        private dialogRef: MatDialogRef<StudentSearchComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any,
        private dialog: MatDialog,
        private dataQueryService: DataQueryService,
        private sharedService: SharedService,
        private studentListsService: StudentListsService,
        private userService: UserService,
        private classroom360Service: Classroom360Service,
        private securityService: SecurityService
    ) {
    }

    get currentQuery(): DataQuery {
        return this._currentQuery;
    }

    set currentQuery(value: DataQuery) {
        this.dataQueryService.currentQuery = value;
        this.searchCriteria.currentQuery = value;
    }

    get studentList(): StudentList {
        return this._studentList;
    }

    set studentList(value: StudentList) {
        this._studentList = value;
        if (this._studentList) {
            this.searchCriteria.listId = this._studentList.ID;
        } else {
            this.searchCriteria.listId = -1;
        }
    }

    // Lifecycle Hooks
    dateComparator = (a, b) => this.compareByDate(a, b);

    ngOnInit(): void {

        // Setting initial values
        this.isV10 = this.loginService.LoginSettings.V10;
        this.currentYear = this.yearService.defaultYear;
        this.selectedStudentHistory = this.studentService.recentStudents;
        this.creatingStudentList = this.data.creatingStudentList;

        // Obtaining the schools and setting the "all" value
        if (this.isV10 && this.data.schools) {
            this.schools = this.data.schools;
            this.allSchoolsValue = '';
            this.schools.forEach(school => {
                if (this.allSchoolsValue) {
                    this.allSchoolsValue += ',';
                }
                this.allSchoolsValue += school.Id;
            });
            // ONE-17063
            if (this.allSchoolsValue.length == 0) {
                this.allSchoolsValue = '0';
            }
        } else {
            if (!this.isV10 && this.yearService.schoolsForC360 && this.yearService.schools.length < this.yearService.schoolsForC360.length) {
                this.schools = this.yearService.schoolsForC360;
            } else {
                this.schools = this.yearService.schools;
            }
            this.allSchoolsValue = '0';
        }

        this.useLastSelectedSchool = this.data.useLastSelectedSchool == null ? true : this.data.useLastSelectedSchool;

        // Setting up initial display ???
        this.sortSchools();
        this.setPreferences();
        this.getSearchCriteria();
        this.getStudentSearchPreferences();

        // Loading criteria
        this.loadSearchCriteria();
        this.loadFilterCriteria();
        this.getStudentLists();

        // Obtaining permissions
        if (this.isV10) {
            if (this.securityService.userPermissions.find(o => o.PrivilegeId == this.addStudentListPrivilegeId) != null) {
                this.addStudentList = true;
            }
        }
        else {
            this.addStudentList = true;
        }

        // Build out the column Definitions ** Needs to Be Here (ngOnInit) **
        if (this.data) {
            if (this.data.disableSchoolDropdown) {
                this.disableSchoolDropdown = this.data.disableSchoolDropdown;
            }
            if (this.data.clickHandler) {
                this.clickHandler = this.data.clickHandler;
            }
            if (this.data.schoolId) {
                this.searchCriteria.schoolId = this.data.schoolId.toString();
            } else if (this.data.currentSchool) {
                this.searchCriteria.schoolId = this.yearService.defaultYear.SchoolID.toString();
            }
            if (this.data.returnSelectedStudents) {
                this.returnSelectedStudents = this.data.returnSelectedStudents;
            }
            if (this.data.selectedStudents) {
                this.selectedStudents = System.copyArray(this.data.selectedStudents);
            }
            if (this.data.viewAllStudentsInThisSchoolYear) {
                this.searchCriteria.viewAllStudentInThisSchoolYear = this.data.viewAllStudentsInThisSchoolYear;
            }
            if (this.data.headerMessage) {
                this.headerMessage = this.data.headerMessage;
            }
            if (this.data.acceptLabel) {
                this.acceptLabel = this.data.acceptLabel;
            }
            if (this.data.referral) {
                this.referral = this.data.referral;
            }
            if (this.data.hidNextButton) {
                this.hidNextButton = this.data.hidNextButton;
            }
            if (this.data.hideSaveButton) {
                this.hideSaveButton = this.data.hideSaveButton;
            }
            if (this.data.showLargeHeaderMessage) {
                this.showLargeHeaderMessage = this.data.showLargeHeaderMessage;
            }
        }
        this.performRoute = this.data.performRoute;
        this.searchAndSelect = this.data.searchAndSelect;
        if (this.data.callFromSpedHome == true) {
            this.redirectUrl = '/sped360/studentDocumentHome';
        } else {
            this.redirectUrl = this.data.redirectUrl;
        }
        this.returnSingle = this.data.returnSingle;
        this.returnAll = this.data.returnAll;
        // Set the default sort order based on the user preference
        if (this.userPreferencesService.generalPreferences.StudentNameFormat == 'LNF') {
            this.sortOrder = [{ prop: 'LastName', dir: 'asc' }];
            this.shortingBy = 'LastName';
        } else {
            this.sortOrder = [{ prop: 'FirstName', dir: 'asc' }];
            this.shortingBy = 'FirstName';
        }

        // Subscribing to data query values
        this.studentSearchService.unsavedStudentFilter = false;
        this.dataQueryService.getInformation().subscribe();
        this.dataQueryService.currentQuery = new DataQuery();
        this.dataQueryService.isStudentSearch = true;
        this.dataQueryService.pageSize = this.dataQueryService.initialPageSize;
        this.subscriptions.push(
            // Syncing properties
            this.dataQueryService.observableCurrentQueryStream$.subscribe(query => {
                this._currentQuery = query;
                this._currentQuery.StudentSearch = true;
                this._currentQuery.CourseSearch = false;
                this.dataQueryService.checkDefaultFilterFields(this._currentQuery.filterFields);
            }),
            this.dataQueryService.observableInformationStream$.subscribe(information => {
                this.information = information;
                if (this.currentQuery && !this.information.recentStudentFilters.find(filterQuery => filterQuery == this.currentQuery)) {
                    const matchingQuery = this.information.recentStudentFilters.find(filterQuery => filterQuery.ID == this.currentQuery.ID);
                    if (matchingQuery) {
                        this.currentQuery = matchingQuery;
                    }
                }
                if (!this.dataQueryService.obtainedRecentStudentQueries && !this.dataQueryService.isInformationCached()) {
                    this.subscriptions.push(
                        this.dataQueryService.getRecentQueries().subscribe(recentFilters => {
                            this.information.recentStudentFilters = recentFilters;
                            this.dataQueryService.obtainedRecentStudentQueries = true;
                        })
                    );
                }
            }),

            // Obtaining data
            this.dataQueryService.getPermissions().subscribe()
        );
        // Resetting the filter query
        this.currentQuery = new DataQuery();
        this.dataQueryService.currentSchoolOnly = false;
        if (this.studentSearchService.searchCriteria) {
            if (this.studentSearchService.searchCriteria.currentQuery) {
                this.currentQuery = this.information.recentStudentFilters.find(rf => rf.ID == this.studentSearchService.searchCriteria.currentQuery.ID);
            }
        }
        // default table columans
        if (this.searchAndSelect) {
            this.columnsToDisplay = ['SelectAll'];
        }
        else {
            this.columnsToDisplay = [];
        }
        for (let i = 0; i < this.defaultMatTableColumns.length; i++) {
            if (this.defaultMatTableColumns[i].active == true && (this.defaultMatTableColumns[i].name != 'Alerts' || this.showStudentAlerts == true)) {
                this.columnsToDisplay.push(this.defaultMatTableColumns[i].MatTableColumn);
            }
        }
    }
    chooseColumn() {
        if (this.searchAndSelect) {
            this.columnsToDisplay = ['SelectAll'];
        }
        else {
            this.columnsToDisplay = [];
        }
        for (let i = 0; i < this.defaultColumns.length; i++) {
            if (this.defaultColumns[i].active == true && (this.defaultColumns[i].name != 'Alerts' || this.showStudentAlerts == true)) {
                for (let j = 0; j < this.defaultMatTableColumns.length; j++) {
                    if (this.defaultColumns[i].name == this.defaultMatTableColumns[j].name) {
                        this.columnsToDisplay.push(this.defaultMatTableColumns[i].MatTableColumn);
                        break;
                    }
                }
            }
        }
    }
    ngAfterViewInit(): void {
        // Get the students
    }
    getCellClass = ({ row, column, value }): any => {
        if (!this.isV10) {
            if (value == 'Projected') {
                return ' ProjectedStudent';
            }
            else if (value == 'Withdrawn') {
                return ' WithdrawnStudent';
            }
            else if (value == 'Future') {
                return ' FutureStudent';
            }
        }
        return '';
    }
    ngOnDestroy(): void {
        if (!this.closeClicked) {
            // Saves to the database
            this.saveStudentSearchPreferences();
        }

        // Unsubscribing from all subscriptions
        this.subscriptions.forEach(subscription => {
            subscription.unsubscribe();
        });

        // Replacing the current query in case we were in data query
        this.dataQueryService.isStudentSearch = false;
        this.dataQueryService.isCourseSearch = false;
        // Saves to the service for the session
        this.studentSearchService.saveFilterCriteria(this.activeFilters);
    }

    closeClick() {
        this.saveSearchCriteria();
        this.saveStudentSearchPreferences();
        if (this.loginService.LoginSettings.ActivateClassroom360 == false && (this.studentService.selectedStudent == null || this.studentService.selectedStudent.Id == null)) {
            const studentSearchWarningDialogRef = this.dialog.open(StudentSearchWarningComponent, {
                panelClass: 'tyl-mat-dialog',
                minWidth: '500px',
                disableClose: true
            });

            studentSearchWarningDialogRef.afterClosed().subscribe(result => {
                if (result == 'OK was clicked.') {
                    this.closeClicked = true;
                    this.dialogRef.close();
                }
            });
        } else {
            this.closeClicked = true;
            this.dialogRef.close();
        }
    }

    saveSearchCriteria() {
        const previousSchoolId = this.searchCriteria.schoolId;
        this.studentSearchService.searchCriteria = this.searchCriteria;
        this.studentSearchService.searchCriteria.currentQuery = null;   // We don't save filters
    }

    checkStudentFilter() {
        // Checks to see if a student filter is active
        // return true to disable the header filters
        return this.studentSearchService.unsavedStudentFilter || this.currentQuery.ID != -1;
    }

    enterStudentNumbers() {
        // PRE: the CSV button next to student number is clicked
        // POST: opens the enter CSV dialog as "Enter Student Numbers"
        const dialogBox = this.dialog.open(EnterCsvDialogComponent, {
            disableClose: true,
            data: {
                header: 'Enter Student Numbers',
                helpString: 'Separate numbers with a comma (Ex. 12345,13423,12312,19712)',
                pattern: this.studentNumberRegExp,
                keyRestriction: this.studentNumberKeyRestriction,
                validator: (csv: string): ErrorList[] => {
                    if (!csv) {
                        return [
                            {
                                errorMsg: 'Required field.',
                                fieldName: 'Student Numbers',
                                fieldRef: new ElementRef(null)
                            }
                        ];
                    }
                    if (csv[csv.length - 1] == ',') {
                        return [
                            {
                                errorMsg: 'The CSV must not end with a comma.',
                                fieldName: 'Student Numbers',
                                fieldRef: new ElementRef(null)
                            }
                        ];
                    } else if (!csv.match(this.studentNumberRegExp)) {
                        return [
                            {
                                errorMsg: 'Separate numbers by commas. No spaces or special characters.',
                                fieldName: 'Student Numbers',
                                fieldRef: new ElementRef(null)
                            }
                        ];
                    }
                    return [];
                }
            }
        });
        this.subscriptions.push(
            dialogBox.afterClosed().subscribe(csv => {
                if (csv || csv == '') {
                    this.searchCriteria.studentNumber = csv;
                }
            })
        );
    }

    loadSearchCriteria() {
        if (this.studentSearchService.searchCriteria) {
            this.searchCriteria.studentNumber = this.studentSearchService.searchCriteria.studentNumber;
            this.searchCriteria.firstName = this.studentSearchService.searchCriteria.firstName;
            this.searchCriteria.lastName = this.studentSearchService.searchCriteria.lastName;
            this.searchCriteria.schoolId = this.useLastSelectedSchool ? this.studentSearchService.searchCriteria.schoolId : this.yearService.defaultYear.SchoolID.toString();
            this.searchCriteria.status = this.studentSearchService.searchCriteria.status;
            this.searchCriteria.currentQuery = this.studentSearchService.searchCriteria.currentQuery;
        }

        // Loading the all value if the loaded school doesn't exist
        if (this.schools.findIndex(s => s.Id.toString() == this.searchCriteria.schoolId) < 0) {
            this.searchCriteria.schoolId = (this.allSchoolsValue != '') ? this.allSchoolsValue : '0';
        }
    }

    loadFilterCriteria() {
        if (this.studentSearchService.filterCriteria) {
            this.studentSearchService.filterCriteria.forEach(f => {
                this.activeFilters.push(f);
            });
            this.activeFilters.forEach(f => {
                switch (f.name) {
                    case 'StudentNumber':
                        this.studentNumberFilter = f.filter;
                        break;
                    case 'FirstName':
                        this.firstNameFilter = f.filter;
                        break;
                    case 'LastName':
                        this.lastNameFilter = f.filter;
                        break;
                    case 'Grade':
                        this.gradeFilter = f.filter;
                        break;
                    case 'Enrollment':
                        this.enrollmentFilter = f.filter;
                        break;
                    case 'EnrollmentDate':
                        this.enrollDateFilter = f.filter;
                        break;
                    case 'DateOfBirth':
                        this.dateOfBirthFilter = f.filter;
                        break;
                    case 'EnrollmentSchool':
                        this.schoolFilter = f.filter;
                        break;
                    case 'EnrollmentStatus':
                        this.statusFilter = f.filter;
                        break;
                }
            });
        }
    }

    clearFilters() {
        this.studentNumberFilter = '';
        this.firstNameFilter = '';
        this.lastNameFilter = '';
        this.gradeFilter = '';
        this.enrollmentFilter = '';
        this.enrollDateFilter = '';
        this.dateOfBirthFilter = '';
        this.schoolFilter = '';
        this.statusFilter = '';
    }

    getStudentLists() {
        // POST: obtains the student lists from the server
        this.studentListsService.getStudentLists(
            false,
            this.searchCriteria.schoolId ? parseInt(this.searchCriteria.schoolId, 10) : this.yearService.defaultYear.SchoolID
        ).pipe(take(1)).subscribe(studentLists => {
            if (studentLists) {
                this.studentLists = studentLists.sort((a, b) =>
                    a.Name.localeCompare(b.Name)
                );

                // Check for a student list in the session
                if (this.studentSearchService.searchCriteria) {
                    if (this.studentSearchService.searchCriteria.listId) {
                        this.studentList = this.studentLists.find(sl => sl.ID == this.studentSearchService.searchCriteria.listId);
                    }
                }
            }
        });
    }

    getStudents() {
        // Check if the homeroom teacher column is active
        this.defaultColumns.forEach(c => {
            if (c.name === 'Homeroom Teacher') {
                this.searchCriteria.getStudentHomerooms = c.active;
            }
        });
        this.subscriptions.push(
            this.studentSearchService.getStudentsBySearchCriteria(
                this.searchCriteria
            ).subscribe(
                data => {
                    this.studentSearchCalled = true;
                    this.originalStudentSearchData = JSON.parse(JSON.stringify(data));
                    const studentData = data as StudentSearchModel[];
                    this.studentSearchData = [];
                    this.studentIds = [];
                    // Convert the StudentSearchDTO to a student object
                    for (let i = 0; i < studentData.length; i++) {
                        const student = new Student();
                        student.Id = studentData[i].StudentId;
                        student.Grade = studentData[i].Grade;
                        student.EnrollmentId = studentData[i].EnrollmentId;
                        student.Enrollment = studentData[i].Enrollment;
                        student.EnrollmentSchool = studentData[i].EnrollmentSchool;
                        student.EnrollmentDate = moment(studentData[i].EnrollmentDate).format('MM/DD/YY');
                        student.EnrollmentDateAsDate = new Date(studentData[i].EnrollmentDate);
                        student.EnrollmentStatus = studentData[i].EnrollmentStatus;
                        student.StudentNumber = studentData[i].StudentNumber;
                        student.LastName = studentData[i].LastName;
                        student.FirstName = studentData[i].FirstName;
                        student.MiddleName = studentData[i].MiddleName;
                        student.NickName = studentData[i].NickName;
                        student.DateOfBirth = moment(studentData[i].DOB).format('MM/DD/YY');
                        student.DateOfBirthAsDate = new Date(studentData[i].DOB);
                        student.IEP = studentData[i].IEP;
                        student.StudentAlerts = studentData[i].StudentAlerts;
                        student.isSelected = false;
                        student.HomeRoom_Class = studentData[i].HomeRoom_Class;
                        student.Homeroom_CourseSection = studentData[i].Homeroom_CourseSection;
                        student.Homeroom_Teacher = studentData[i].Homeroom_Teacher;
                        student.StudentDOENumber = (studentData[i].State_ID != null) ? studentData[i].State_ID : '';
                        // Add the ID to the list of studentIds
                        this.studentIds.push(studentData[i].StudentId);

                        if (this.userPreferencesService.generalPreferences != null && this.userPreferencesService.generalPreferences.ShowNickname && student.NickName != null && student.NickName != '') {
                            student.FirstName = student.FirstName + ' \"' + student.NickName + '\"';
                        }

                        // Marking it as selected if it is in our selected students
                        for (let j = 0; j < this.selectedStudents.length; j++) {
                            if (student.Id == this.selectedStudents[j].Id) {
                                this.selectedStudents[j] = student;
                            }
                        }

                        // Add the student to the data grid
                        this.studentSearchData.push(student);
                    }
                    this.studentGridData = this.studentSearchData;
                    this.dataSource.data = this.studentGridData;
                    if (!this.searchCriteriaLoaded) {
                        this.updateSearchCriteria();
                    }
                    // If we have a list of selected students (passed in), mark them as selected
                    if (this.selectedStudents.length > 0) {
                        this.selectedStudents.forEach(s => {
                            const studentObject = this.studentSearchData.find(o => Number(o.StudentNumber) == Number(s.StudentNumber));
                            if (studentObject) {
                                if (this.isV10) {
                                    Object.assign(s, studentObject);
                                }
                                studentObject.isSelected = true;
                            }
                        });
                    }
                    this.selectCheckBoxChange();
                    this.processFilters();
                }, err => {
                    // Error Getting Students
                    console.log(err);
                }
            )
        );
    }

    getStudentSearchPreferences() {
        this.subscriptions.push(
            this.studentSearchService.getUserPreferences(0, '/studentSearchGrid').subscribe(data => {
                const studentSearchPreferences = JSON.parse(data[0]);
                // Make sure the user is using the latest version of settings
                if (studentSearchPreferences.hasOwnProperty('columnSettings')) {
                    if (studentSearchPreferences.columnSettings.length == this.defaultColumns.length) {
                        this.defaultColumns = studentSearchPreferences.columnSettings;
                        this.setMatHeader();
                    } else {
                        this.saveStudentSearchPreferences();
                    }
                } else {
                    this.saveStudentSearchPreferences();
                }
                if (this.prepopulateStudentSearch) {
                    this.getStudents();
                }
            })
        );
    }

    keyDownFunction(event) {
        if (event.keyCode == 13) {
            this.searchClick();
        }
    }

    menuClick() {
        // Do something when the menu is clicked
    }

    route() {

        if (this.redirectUrl != null && this.redirectUrl != '') {
            this.router.navigateByUrl(this.redirectUrl);
        } else if ((!this.sharedService.currentPortal || !this.sharedService.currentPortal.applyFilterStudents)) {
            this.router.navigateByUrl('/student360/studentSummary');
        }
        this.dialogRef.close(true);
    }

    onSelectionChanged(event, rowData) {
        // Helper Functions
        const returnSingleStudent = () => {
            // POST: returns the single selected student
            this.inputBuffer = true;
            if (!this.referral) {
                this.saveStudentSearchPreferences();
            }
            const selectedStudent = rowData;
            if (this.userPreferencesService.generalPreferences != null && this.userPreferencesService.generalPreferences.ShowNickname) {
                const student = this.originalStudentSearchData.find(o => o.StudentId == selectedStudent.Id);
                if (student != null) {
                    selectedStudent.FirstName = student.FirstName;
                }
            }
            this.dialogRef.close(selectedStudent);
            setTimeout(() => {
                this.inputBuffer = false;
            }, 1000);
        };
        const setStudentsToAllStudents = (callBack?: Function) => {
            // PRE: a callback function if you need to do processing after
            // POST: sets the selected students to all the students in the list, then performs the callback
            const selectedStudent: Student = rowData;
            const selectedStudents = [];
            for (let i = 0; i < this.dataSource.data.length; i++) {
                if (this.userPreferencesService.generalPreferences != null && this.userPreferencesService.generalPreferences.ShowNickname && this.dataSource.data[i].NickName != null && this.dataSource.data[i].NickName != '') {
                    const student = this.originalStudentSearchData.filter(o => o.StudentId == this.dataSource.data[i].Id)[0];
                    if (student != null) {
                        this.dataSource.data[i].FirstName = student.FirstName;
                    }
                }
                selectedStudents.push(this.dataSource.data[i]);
            }
            this.subscriptions.push(
                this.studentService.getStudent(selectedStudent.Id).subscribe(student => {
                    const studentIndex = selectedStudents.findIndex(x => x.Id == student.Id);
                    // Grade is NULL in getStudent Method.  ONE-10790 #2
                    student.Grade = selectedStudents[studentIndex].Grade;

                    // Using the callback
                    if (callBack) {
                        callBack(selectedStudents, studentIndex);
                    }

                    // Updating the student
                    selectedStudents[studentIndex] = student;
                    this.studentService.updateStudents(selectedStudents, studentIndex);
                })
            );
        };

        // Making sure the event's row is set
        event.row = rowData;

        // Handling the click event
        if (event.type == 'click') {
            this.saveSearchCriteria();
            if (this.searchAndSelect) {
                // other search and select logic here
                if (rowData != undefined) {
                    rowData.isSelected = !rowData.isSelected;
                    // Manage the selected student list
                    if (rowData.isSelected) {
                        this.selectedStudents.push(rowData);
                    } else {
                        this.selectedStudents = this.selectedStudents.filter(s => s.Id !== rowData.Id);
                    }

                    // ############
                    if (this.dataSource.sort.direction == 'asc') {
                        this.selectedStudents = _.orderBy(this.selectedStudents, [this.dataSource.sort.active], ['asc']);
                    }
                    if (this.dataSource.sort.direction == 'desc') {
                        this.selectedStudents = _.orderBy(this.selectedStudents, [this.dataSource.sort.active], ['desc']);
                    }
                    // ############

                    // check the selection
                    this.selectCheckBoxChange();
                }
            } else if (this.returnSingle) {
                if (rowData != undefined) {
                    //  inputBuffer prevents user double clicking and calling saveStudentSearchPreferences() twice
                    if (!this.inputBuffer) {
                        returnSingleStudent();
                    }
                }
            } else if (this.returnAll) {
                if (rowData != undefined) {
                    //  inputBuffer prevents user double clicking and calling saveStudentSearchPreferences() twice
                    if (!this.inputBuffer) {

                        // Selecting out all the students
                        setStudentsToAllStudents(() => {

                            // Returning the selected student
                            returnSingleStudent();
                        });
                    }
                }
            } else {
                this.saveStudentSearchPreferences();
                if (rowData != undefined && this.userPreferencesService.generalPreferences != null && this.userPreferencesService.generalPreferences.ShowNickname) {
                    const student = this.originalStudentSearchData.find(o => o.StudentId == rowData.Id);
                    if (student != null) {
                        rowData.FirstName = student.FirstName;
                    }
                }
                this.clickHandler(event);
                if (this.performRoute) {
                    setStudentsToAllStudents(() => {

                        // Waiting for portal changes before routing
                        // TODO: fix hacky solution #Justin
                        let numHits = 0;
                        const subscription = this.classroom360Service.observableStaffAssignedPortalsStream$.subscribe(() => {
                            numHits += 1;
                            if (numHits == 2) {
                                this.route();
                                subscription.unsubscribe();
                            }
                        });
                    });
                } else {
                    this.dialogRef.close(true);
                }
            }
        }
    }

    startOverClick() {
        this.restoreDefaultsClick();
        this.studentSearchService.filterCriteria = undefined;
        this.studentSearchService.unsavedStudentFilter = false;
        this.searchCriteria = new StudentSearchCriteria(
            this.yearService.defaultYear.Id,
            '',
            '',
            '',
            this.data && this.data.schoolId ? this.data.schoolId.toString() : this.yearService.defaultYear.SchoolID.toString(),
            'Active',
        );
        this.activeFilters = [];
        this.currentQuery = undefined;
        this.studentList = undefined;
        this.selectedStudents = [];
        this.allStudentsSelected = false;
        this.clearFilters();
        this.studentSearchData = [];
        this.studentGridData = [];
        this.dataSource.data = this.studentGridData;
        if (this.prepopulateStudentSearch) {
            this.getStudents();
        }
    }

    restoreDefaultsClick() {
        // reset the visible state on the default columns array
        this.defaultColumns = [
            { name: 'Student #', active: true, regEx: 'startsWith' },
            { name: 'First Name', active: true, regEx: 'startsWith' },
            { name: 'Last Name', active: true, regEx: 'startsWith' },
            { name: 'Alerts', active: true, regEx: 'startsWith' },
            { name: 'Grade', active: true, regEx: 'startsWith' },
            { name: 'Enrollment', active: true, regEx: 'startsWith' },
            { name: 'Enroll Date', active: true, regEx: 'startsWith' },
            { name: 'DOB', active: true, regEx: 'startsWith' },
            { name: 'School', active: true, regEx: 'startsWith' },
            { name: 'Status', active: true, regEx: 'startsWith' },
            { name: 'Homeroom Teacher', active: false, regEx: 'startsWith' },
            { name: 'State ID', active: false, regEx: 'startsWith' },
        ];
        this.setMatHeader();
    }

    setMatHeader() {
        this.defaultColumns.forEach(dc => {
            this.defaultMatTableColumns.forEach(dmc => {
                if (dc.name == dmc.name) {
                    dmc.active = dc.active;
                }
            });
        });
        if (this.searchAndSelect) {
            this.columnsToDisplay = ['SelectAll'];
        }
        else {
            this.columnsToDisplay = [];
        }
        for (let i = 0; i < this.defaultMatTableColumns.length; i++) {
            if (this.defaultMatTableColumns[i].active == true && (this.defaultMatTableColumns[i].name != 'Alerts' || this.showStudentAlerts == true)) {
                this.columnsToDisplay.push(this.defaultMatTableColumns[i].MatTableColumn);
            }
        }
    }

    saveStudentSearchPreferences() {
        const prefs = new StudentSearchPreferences();
        prefs.columnSettings = this.defaultColumns;
        const xmlStream = [];
        xmlStream.push(JSON.stringify(prefs));
        // NOTE: we unsubscribe imperatively here to prevent it from being cancelled preemptively
        const subscription = this.studentSearchService.saveUserPreferences(0, '/studentSearchGrid', xmlStream).subscribe(
            data => {
                subscription.unsubscribe();
            },
            err => {
                console.log(err);
                subscription.unsubscribe();
            }
        );
    }

    searchClick() {
        this.saveSearchCriteria();
        if (this._currentQuery.filterFields.length > 0) {
            const schoolIds = '';
            // this.yearService.schools.forEach(school => {
            //     if (school.SchoolName == this.dataQueryService.studentSearchFilters.ddlSchool || this.dataQueryService.studentSearchFilters.ddlSchool == '') {
            //         schoolIds = schoolIds + (schoolIds == '' ? school.Id.toString() : ',' + school.Id.toString());
            //     }
            // })

            this.dataQueryService.getResults(
                false,
                (results: DataQueryResult) => {
                    this.processStudentFilterResults(results);
                },
                () => {
                },
                true,
                true,
                schoolIds
            );
        } else {
            this.getStudents();
            this.allStudentsSelected = false;
        }
    }

    selectClick() {
        if (this.returnSelectedStudents) {
            if (this.userPreferencesService.generalPreferences != null && this.userPreferencesService.generalPreferences.ShowNickname) {
                this.selectedStudents.forEach(obj => {
                    const student = this.originalStudentSearchData.find(o => o.StudentId == obj.Id);
                    if (student != null) {
                        obj.FirstName = student.FirstName;
                    }
                });
            }

            this.dialogRef.close(this.selectedStudents);
        } else {
            this.dialogRef.close();
        }
    }

    selectedSchoolChanged(event) {
        this.searchCriteria.schoolId = event.value;
        this.getStudentLists();
    }

    selectedStatusChanged(event) {
        this.searchCriteria.status = event.value;
    }

    studentFilterChange(event) {
        // Check if the user selected none in the student filter dropdown
        if (event.value == null) { // none
            // if so reset the unsavedStudentFilter
            this.studentSearchService.unsavedStudentFilter = false;
        }
        this.clearColumnFilters();
    }

    clearColumnFilters() {
        this.activeFilters = [];
        this.studentNumberFilter = undefined;
        this.firstNameFilter = undefined;
        this.lastNameFilter = undefined;
        this.gradeFilter = undefined;
        this.enrollmentFilter = undefined;
        this.enrollDateFilter = undefined;
        this.dateOfBirthFilter = undefined;
        this.schoolFilter = undefined;
        this.statusFilter = undefined;
    }

    studentFiltersClick() {
        // PRE: the student filter's button is clicked
        // POST: opens the student filter dialog. When closed with results, displays those results on the grid
        if (this.searchCriteria.schoolId) {
            const school = this.schools.find(s => s.Id.toString() == this.searchCriteria.schoolId);
            this.dataQueryService.studentSearchFilters.ddlSchool = school ? school.SchoolName : '';
        }
        this.dataQueryService.studentSearchFilters.rbStatus = this.searchCriteria.status;
        const dialogBox = this.dialog.open(AdvancedStudentSearchComponent, {
            disableClose: true,
            maxWidth: '100vw',
            maxHeight: '100vh',
            width: '100%',
            height: '100%',
            data: {
                initialStudentNumber: this.studentNumberFilter,
                initialFirstName: this.firstNameFilter,
                initialLastName: this.lastNameFilter,
                initialGrade: this.gradeFilter,
                initialEnrollment: this.enrollmentFilter,
                initialEnrollDate: this.enrollDateFilter,
                initialDOB: this.dateOfBirthFilter,
                initialSchool: this.schoolFilter,
                initialStatus: this.statusFilter
            }
        });
        this.subscriptions.push(
            dialogBox.afterClosed().subscribe((results: DataQueryResult) => {
                if (results) {
                    this.studentSearchService.unsavedStudentFilter = !this.currentQuery.QueryName;
                    this.selectedStudents = [];
                    this.clearColumnFilters();
                    this.processStudentFilterResults(results);
                }
            })
        );
    }

    processStudentFilterResults(results: DataQueryResult) {
        // PRE: a set of results obtained by student filter
        // POST: composes students from those results and updates the displayed data
        if (!results) {
            return;
        }
        const newData: Student[] = [];
        results.Data.forEach(datum => {
            const newStudent = new Student();
            for (let i = 0; i < results.ColumnHeaders.length; i++) {
                switch (results.ColumnHeaders[i]) {
                    case 'Student Number':
                    case 'Student #':
                    case 'StudentNumber':
                    case 'Student ID':
                        newStudent.StudentNumber = datum[i];
                        break;
                    case 'StudentId':
                    case 'lngStudentId':
                    case 'Student_ID':
                        newStudent.Id = parseInt(datum[i], 10);
                        break;
                    case 'First Name':
                    case 'FirstName':
                    case 'Name - First':
                        newStudent.FirstName = datum[i];
                        break;
                    case 'Last Name':
                    case 'LastName':
                    case 'Name - Last':
                        newStudent.LastName = datum[i];
                        break;
                    case 'Grade':
                    case 'Grade Level':
                        newStudent.Grade = datum[i];
                        break;
                    case 'School':
                    case 'School Name':
                    case 'Primary Enrollment Site Name':
                        newStudent.EnrollmentSchool = datum[i];
                        break;
                    case 'Enrollment Date':
                    case 'Entry Date':
                        newStudent.EnrollmentDate = datum[i];
                        break;
                    case 'Status':
                    case 'Enrollment Status':
                        newStudent.EnrollmentStatus = datum[i];
                        break;
                    case 'DOB':
                    case 'Date of Birth':
                    case 'Birth Date':
                        newStudent.DateOfBirth = datum[i];
                        break;
                    case 'Primary':
                        switch (datum[i]) {
                            case '1':
                                newStudent.Enrollment = 'Primary';
                                break;
                            case '2':
                                newStudent.Enrollment = 'Alternate';
                                break;
                            default:
                                newStudent.Enrollment = datum[i];
                                break;
                        }
                }
            }
            newData.push(newStudent);
        });
        newData.forEach(s => {
            if (s.EnrollmentDate) {
                s.EnrollmentDateAsDate = new Date(s.EnrollmentDate);
            }
            if (s.DateOfBirth) {
                s.DateOfBirthAsDate = new Date(s.DateOfBirth);
            }
        });
        this.studentSearchData = newData;
        if (this.selectedStudents.length > 0) {
            this.selectedStudents.forEach(s => {
                const studentObject = this.studentSearchData.find(o => Number(o.Id) == Number(s.Id));
                if (studentObject) {
                    studentObject.isSelected = true;
                }
            });
            this.selectedStudents = [];
            this.selectedStudents = newData.filter(x => x.isSelected == true);
        }
        this.updateFilter();
    }

    updateFilter(val?, column?) {
        // UPDATING FILTER FOR DATA QUERY
        if (column) {
            this.dataQueryService.studentSearchFilters[column.prop] = column.searchCriteria;
            // Set the regEx for the column
            column.regEx = this.defaultColumns.find(c => c.name == column.name).regEx;
        }

        // Updating the filter value at the specified column
        if (val != undefined && val != null && column != undefined && column != null) {
            val = val.toLowerCase();
            if (this.activeFilters.find(col => col.name == column.prop)) {
                const index = this.activeFilters.map(function (x) {
                    return x.name;
                }).indexOf(column.prop);
                if (val == '') {
                    this.activeFilters.splice(index, 1);
                } else {
                    this.activeFilters[index].filter = val;
                    this.activeFilters[index].regEx = column.regEx;
                }
            } else {
                if (val != '') {
                    const colFilter = { name: column.prop, filter: val, regEx: column.regEx };
                    this.activeFilters.push(colFilter);
                }
            }
        }
        // Reset the data source
        // NOTE: uses the student list if one is provided
        this.studentGridData = this.studentSearchData;
        if (this.activeFilters.length > 0 && column) {
            // loop through and filter
            for (let i = 0; i < this.activeFilters.length; i++) {
                const regEx = RegexDirective.RegExBuilder(this.activeFilters[i].filter, column.regEx);
                this.studentGridData = this.studentGridData.filter(data => {
                    return data[this.activeFilters[i].name].toString().toLowerCase().match(regEx);
                });
            }
        }
        this.dataSource.data = this.studentGridData;
        // Check the select box
        this.selectCheckBoxChange();
    }

    updateRegEx(column, newRegexValue?) {
        // Find the filter in the active filters and update it
        const gridData = _.cloneDeep(this.studentSearchData);
        // Find the column
        const col = this.defaultColumns.find(c => c.name.replace(/\s+/g, '') == column.name.replace(/\s+/g, ''));
        // Update the regEx value
        col.regEx = newRegexValue;
        setTimeout(() => {
            if (this.activeFilters.length > 0) {
                // loop through and filter
                for (let i = 0; i < this.activeFilters.length; i++) {
                    const regEx = RegexDirective.RegExBuilder(this.activeFilters[i].filter, col.regEx);
                    this.studentGridData = gridData.filter(data => {
                        return data[this.activeFilters[i].name].toString().toLowerCase().match(regEx);
                    });
                    this.dataSource.data = this.studentGridData;
                }
            }
        }, 1);
    }

    updateSearchCriteria() {
        if (this.searchCriteria != undefined) {
        }
        this.searchCriteriaLoaded = true;
    }

    lastSelectedStudentClick(lastSelectedStudent: Student) {
        this.studentService.students = this.studentService.recentStudents;
        this.studentService.updateSelectedStudent(lastSelectedStudent.Id);
        this.subscriptions.push(
            this.studentService.selectedStudentStream$.subscribe(() => {
                if (this.redirectUrl != null && this.redirectUrl != '') {
                    this.router.navigateByUrl(this.redirectUrl);
                } else {
                    this.router.navigateByUrl('/student360/studentSummary');
                }
                this.dialogRef.close();
            })
        );
    }

    createStudentList() {
        // POST: creates a student list
        //       if this is student search and select, uses the selected students
        //       if this is not student search and select, uses the visible students
        let students: Student[];
        if (this.searchAndSelect) {
            students = this.selectedStudents;
        } else {
            // students = this.studentGridData;
            students = this.dataSource.filteredData;
        }
        const dialogBox = this.dialog.open(AddEditStudentListDialogComponent, {
            disableClose: true,
            data: {
                students: students,
                addMode: true,
                editMode: false,
                disableStudents: true
            }
        });
        this.subscriptions.push(
            dialogBox.afterClosed().subscribe(studentList => {
                if (studentList) {
                    this.studentLists.push(studentList);
                    this.studentLists = this.studentLists.sort((a, b) =>
                        a.Name.localeCompare(b.Name)
                    );
                    this.studentSearchService.addStudentListEvent.emit(studentList);
                }
            })
        );
    }

    showSelectedStudents() {
        if (this.selectedStudents.length > 0) {
            this.displaySelectedStudentsModal(this.selectedStudents);
        }
    }

    massEmail() {
        const massEmail = new MassEmail();
        massEmail.ReferringPage = 'Student Search';
        if (this.searchAndSelect) {
            massEmail.StudentIds = this.selectedStudents.map(student => student.Id);
        } else {
            massEmail.StudentIds = this.dataSource.filteredData.map((student: Student) => student.Id);
        }
        this.dialog.open(MassEmailViewComponent, {
            panelClass: 'tyl-mat-dialog',
            width: '100vw',
            height: '100vh',
            maxWidth: '100vw',
            maxHeight: '100vh',
            disableClose: true,
            data: {
                massEmail: massEmail
            },
        });
    }

    displaySelectedStudentsModal(students) {
        this.dialog.open(StudentListModalComponent, {
            minWidth: '60%',
            minHeight: '50%',
            maxHeight: '65%',
            autoFocus: false,
            disableClose: true,
            data: students
        }).afterClosed().subscribe(message => {
            if (message == 'ClearStudents') {
                this.selectedStudents = [];
                if (this.data.selectedStudents) {
                    this.data.selectedStudents = [];
                }
                this.studentGridData.forEach(s => {
                    s.isSelected = false;
                });
                this.dataSource.data = this.studentGridData;
            }
        });
    }

    private sortSchools() {
        this.schools = this.schools.sort(function (a, b) {
            if (a.SchoolName < b.SchoolName) {
                return -1;
            }
            if (a.SchoolName > b.SchoolName) {
                return 1;
            }
            return 0;
        });
    }

    private setPreferences() {
        if (this.userPreferencesService.generalPreferences != null) {
            this.defaultCursorPosition = this.userPreferencesService.generalPreferences.DefaultCursorPosition;
            this.showStudentAlerts = this.userPreferencesService.generalPreferences.ShowStudentAlerts;
            this.prepopulateStudentSearch = this.userPreferencesService.generalPreferences.PrepopulateStudent;
        } else {
            this.defaultCursorPosition = 1;
            this.showStudentAlerts = false;
            this.prepopulateStudentSearch = true;
        }
    }

    private getSearchCriteria() {
        this.searchCriteria = this.studentSearchService.getSearchCriteria();
        if (!this.searchCriteria) {
            this.searchCriteria = new StudentSearchCriteria(
                this.yearService.defaultYear.Id,
                '',
                '',
                '',
                this.yearService.defaultYear.SchoolID.toString(),
                'Active'
            );
        }
    }

    selectAllCheckBoxChange() {
        // ---ONE-ONE-10914----
        this.dataSource.filteredData.forEach(s => {
            s.isSelected = this.allStudentsSelected;
        });
        this.selectedStudents = [];
        // Add to the selected student list
        this.dataSource.filteredData.forEach(s => {
            if (s.isSelected) {
                if (this.selectedStudents.indexOf(s) == -1) {
                    this.selectedStudents.push(s);
                }
            } else {
                this.selectedStudents = this.selectedStudents.filter(stu => stu.Id !== s.Id);
            }
        });

        // ############
        if (this.dataSource.sort.direction == 'asc') {
            this.selectedStudents = _.orderBy(this.selectedStudents, [this.dataSource.sort.active], ['asc']);
        }
        if (this.dataSource.sort.direction == 'desc') {
            this.selectedStudents = _.orderBy(this.selectedStudents, [this.dataSource.sort.active], ['desc']);
        }
        // ############
    }

    selectCheckBoxChange() {
        if (this.studentGridData.filter(s => s.isSelected == true).length == this.studentGridData.length) {
            this.allStudentsSelected = true;
        } else {
            this.allStudentsSelected = false;
        }
    }

    showColumn(columnName: string) {
        return this.defaultColumns.find(s => s.name == columnName).active;
    }

    getRegEx(columnName: string, regExValue?: string) {
        const col = this.defaultColumns.find(c => c.name == columnName);
        const reg = this.regularExpressions.find(r => r.value == col.regEx);
        if (reg) {
            return reg.value == regExValue;
        }
    }

    getRowClass = (row) => {
        if (row.isSelected) {
            return 'selected-row';
        }
    }

    validateStudentNumberKey(event: KeyboardEvent) {
        // PRE: a key is entered into the csv
        // POST: ensures that it matches the format
        if (!this.studentNumberKeyRestriction.test(event.key) &&
            event.key != 'Backspace' &&
            event.key != 'Tab') {
            event.preventDefault();
            return false;
        }
    }

    processFilters() {
        const gridData = _.cloneDeep(this.studentSearchData);
        setTimeout(() => {
            if (this.activeFilters.length > 0) {
                // loop through and filter
                for (let i = 0; i < this.activeFilters.length; i++) {
                    const regEx = RegexDirective.RegExBuilder(this.activeFilters[i].filter, this.activeFilters[i].regEx);
                    if (i == 0) {
                        this.studentGridData = gridData.filter(data => {
                            return data[this.activeFilters[i].name].toString().toLowerCase().match(regEx);
                        });
                    }
                    else {
                        this.studentGridData = this.studentGridData.filter(data => {
                            return data[this.activeFilters[i].name].toString().toLowerCase().match(regEx);
                        });
                    }
                    this.dataSource.data = this.studentGridData;
                }
            }
        }, 1);
    }

    private compareByDate(a, b): number {
        a = moment(a, 'MM/DD/YY');
        b = moment(b, 'MM/DD/YY');
        if (a < b) {
            return -1;
        } else if (b < a) {
            return 1;
        } else {
            return 0;
        }
    }

    clearFilter() {
        this.dataSource.removeAllFilters();
    }
}
